<app-header></app-header>
<div [@routeAnimations]="o && o.activatedRouteData 
                        && o.activatedRouteData['animation']">
    <router-outlet #o="outlet"></router-outlet>
</div>

<app-footer></app-footer>